import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=2dcd0030&"
import script from "./Registro.vue?vue&type=script&lang=ts&"
export * from "./Registro.vue?vue&type=script&lang=ts&"
import style0 from "./Registro.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2dcd0030', component.options)
    } else {
      api.reload('2dcd0030', component.options)
    }
    module.hot.accept("./Registro.vue?vue&type=template&id=2dcd0030&", function () {
      api.rerender('2dcd0030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/Registro.vue"
export default component.exports